/**
 * shadcn/ui Textarea on the brand tokens. Author: Mahmoud Ragab Ahmed.
 */
import { fieldControl } from "./input";
import { cn } from "@/lib/utils";

export function Textarea({
  className,
  ...props
}: React.ComponentProps<"textarea">): React.JSX.Element {
  return (
    <textarea
      data-slot="textarea"
      className={cn(fieldControl, "min-h-20 py-2 leading-normal", className)}
      {...props}
    />
  );
}
